import * as React from 'react';
import { useLocation } from 'react-router-dom';
import httpclient from 'libs/Axios';

export const useCancelRequestsOnRouteChange = () => {
    const { pathname } = useLocation();

    React.useEffect(() => (
        () => {
            httpclient().cancelAllRequests();
        }
    ), [pathname]);
};
